import type { ReactNode } from 'react';
import { Icon } from './Icon';
import type { IconName } from './icons';

export function Banner({ tone = 'info', icon, children, action }: { tone?: 'info' | 'demo' | 'warn' | 'error' | 'ok'; icon?: IconName; children: ReactNode; action?: ReactNode }) {
  return (
    <div className={`banner banner-${tone}`} role={tone === 'error' ? 'alert' : undefined}>
      <Icon name={icon ?? (tone === 'error' || tone === 'warn' ? 'warn' : tone === 'ok' ? 'check' : 'info')} size={18} />
      <div className="banner-text">{children}</div>
      {action}
    </div>
  );
}
